module.exports = __webpack_public_path__ + "img/experiences_G STH Of the Game.2a8fb9a3.jpg";